import React, { useState, useEffect, useRef } from 'react';
import axiosInstance from '../axiosConfig';
import { motion } from 'framer-motion';
import Modal from '../Components/Modal';
import { renderAsync } from 'docx-preview';
import { hasPermission } from '../Utils/permissions';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function Department() {
  const [documents, setDocuments] = useState([]);
  const [branch, setBranch] = useState([]);
  const [customer, setCustomer] = useState([]);
  const [department, setDepartment] = useState([]);
  const [currentUser, setCurrentUser] = useState(null);
  const [selectedBranch, setSelectedBranch] = useState(null);
  const [selectedDepartmentName, setSelectedDepartmentName] = useState(null);
  const [selectedDocumentTypes, setSelectedDocumentTypes] = useState([]);
  const [showDepartmentModal, setShowDepartmentModal] = useState(false);
  const [departmentName, setDepartmentName] = useState('');
  const [departmentDescription, setDepartmentDescription] = useState('');
  const [branchName, setBranchName] = useState('');
  const [branchDescription, setBranchDescription] = useState('');
  const [customerName, setCustomerName] = useState('');
  const [customerEmail, setCustomerEmail] = useState('');
  const [customerContactNumber, setCustomerContactNumber] = useState('');
  const [showUpdateDepartmentModal, setShowUpdateDepartmentModal] = useState(false);
  const [showUpdateCustomerModal, setShowUpdateCustomerModal] = useState(false);
  const [selectedDepartmentId, setSelectedDepartmentId] = useState(null);
  const [selectedBranchId, setSelectedBranchId] = useState(null);
  const [selectedCustomerId, setSelectedCustomerId] = useState(null);
  const [showBranchModal, setShowBranchModal] = useState(false);
  const [showCustomerModal, setShowCustomerModal] = useState(false);
  const [departmentId, setDepartmentId] = useState(null);
  const [message, setMessage] = useState('');
  const [documentTypes, setDocumentTypes] = useState({});
  const [showDocumentTypeModal, setShowDocumentTypeModal] = useState(false);
  const [documentTypeName, setDocumentTypeName] = useState('');
  const [category, setCategory] = useState('');
  const [showBranchTableModal, setShowBranchTableModal] = useState(false);
  const [branchNameFilter, setBranchNameFilter] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;
  const [documentTypeFilter, setDocumentTypeFilter] = useState('');
  const [userDepartmentBranch, setUserDepartmentBranch] = useState([])
  const [userCustomers, setUserCustomers] = useState([])
  const [customerFilter, setCustomerFilter] = useState('');
  const [customers, setCustomers] = useState([]);
  const [showCustomerDocumentModal, setShowCustomerDocumentModal] = useState(false);
  const [createdCustomerId, setCreatedCustomerId] = useState(null);
  const [customerDocuments, setCustomerDocuments] = useState({
    pan: null,
    aadhaar: null,
    gst: null,
    other1: null,
    other2: null,
  });
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [showCustomerDetailsModal, setShowCustomerDetailsModal] = useState(false);
  const [customerDocumentImages, setCustomerDocumentImages] = useState({});
  const backendBaseURL = process.env.REACT_APP_API_BASE_URL;
  const [previewImage, setPreviewImage] = useState(null);
  const [previewFile, setPreviewFile] = useState(null);
  const [previewLabel, setPreviewLabel] = useState('');
  const [showUpdateImgModal, setShowUpdateCustomerImgModal] = useState(false);
  const docxContainerRef = useRef(null);
  const [popupopen, setPopupOpen] = useState (false);
  const [ selectedimage, setSelectedImage] = useState (null);
    const [activePath, setActivePath] = useState('');
    const [departments, setDepartments] = useState([]);
      const [departmentsOpen, setDepartmentsOpen] = useState(false);
      const location = useLocation();
      const [selectedDepartment, setSelectedDepartment] = useState('HR');
      const [probationPeriodMonths, setProbationPeriodMonths] = useState("");
// const [probationEndDate, setProbationEndDate] = useState("");
// const [dateOfJoining, setDateOfJoining] = useState("");
const [updateprobationPeriodMonths, setUpdateProbationPeriodMonths] = useState("");
// const [updateprobationEndDate, setUpdateProbationEndDate] = useState("");
// const [updatedateOfJoining, setUpdateDateOfJoining] = useState("");

const [showAssignModal, setShowAssignModal] = useState(false);
const [selectedDepartments, setSelectedDepartments] = useState([]);
const [branches, setBranches] = useState([]);



useEffect(() => {
  const fetchBranches = async () => {
    try {
      const res = await axiosInstance.get('/branch/');
      setBranches(res.data);
    } catch (err) {
      console.error(err);
    }
  };
  fetchBranches();
}, []);


  const handleImageClick = (image, type) =>{
    setSelectedImage(image);
    setPopupOpen(true);
  }

    useEffect(() => setActivePath(location.pathname), [location]);

  useEffect(() => {
    axiosInstance.get('/documents/')
      .then(response => {
        setDocuments(response.data);
      })
      .catch(error => {
        console.error(error);
      });

    axiosInstance.get('/branch/')
      .then(response => {
        setBranch(response.data);
      })
      .catch(error => {
        console.error(error);
      });

    axiosInstance.get('/department/')
      .then(response => {
        setDepartment(response.data);
      })
      .catch(error => {
        console.error(error);
      });

      axiosInstance.get('/document-types/')
    .then(response => {
      setDocumentTypes(response.data);
    })
    .catch(error => {
      console.error(error);
    });

    axiosInstance.get('/user-departments-branches/')
    .then(response => {
      setUserDepartmentBranch(response.data);
    })
    .catch(error => {
      console.error("Error fetching data:", error);
    });

    axiosInstance.get('/get-customers/')
    .then(response => {
      setUserCustomers(response.data.customers);
      setCurrentUser(prev => ({
        ...prev,
        email: response.data.user,
        role_name: response.data.role
      }));
    })
    .catch(error => {
      console.error("Error fetching customers:", error);
    });
     
    const userId = localStorage.getItem('id');
    if (userId) {
      axiosInstance.get(`/user/${userId}/`)
        .then(response => {
          setCurrentUser(response.data);
        })
        .catch(error => {
          console.error("Error fetching user details:", error);
        });
    }
  }, []);
  

  useEffect(() => {
    if (selectedDepartmentName === 'Insurance') {
      axiosInstance.get('customers/')
        .then((response) => {
          setCustomers(response.data);
        })
        .catch((error) => {
          console.error('Failed to fetch customers:', error);
        });
    }
  }, [selectedDepartmentName]);
  
  useEffect(() => {
    if (department && department.length > 0) {
      const hrDept = department.find(
        (dept) => dept.name.toLowerCase() === 'hr'
      );
  
      if (hrDept) {
        setSelectedDepartment(hrDept.id);
        setSelectedDepartmentName(hrDept.name);
        setSelectedDepartmentId(hrDept.id);
        // fetchDocumentTypes(hrDept.name);
      }
    }
  }, [department]);
  

  const handleDepartmentClick = (departmentName) => {
  const departmentObj = department.find((dept) => dept.name === departmentName);
  if (departmentObj) {
    setSelectedDepartment(departmentObj.id); 
    setSelectedDepartmentName(departmentName); 
    setSelectedDepartmentId(departmentObj.id);
    // fetchDocumentTypes(departmentName);
  }
};

  
  
  const handleDepartmentBranchView = (departmentId) => {
    setSelectedDepartmentId(departmentId);
    setShowBranchTableModal(true);
  };
  
  

  // const fetchDocumentTypes = (departmentName) => {
  //   axiosInstance.get(`/fetch-fields/${departmentName}/`)
  //     .then(response => {
  //       setDocumentTypes(response.data);
  //     })
  //     .catch(error => {
  //       console.error(error);
  //     });
  // };

  const handleUpdateBranchClick = (e, branchId) => {
    setSelectedBranchId(branchId);
    setShowUpdateDepartmentModal(true);
  };
  

  const handleUpdateBranch = (e) => {
    e.preventDefault();
    const branchId = selectedBranchId;
  
    const branchData = {
      name: branchName,
      description: branchDescription,
      probation_period_months: probationPeriodMonths,
    };
  
    axiosInstance.patch(`/branch/${branchId}/`, branchData)
      .then(response => {
        console.log(response.data);
        setBranch(branch.map(br => br.id === branchId ? response.data : br));
        setShowUpdateDepartmentModal(false);
      })
      .catch(error => {
        console.error(error);
      });
  };
  

const handleUpdateDepartmentClick = (e, dept) => {
  setSelectedDepartmentId(dept.id);
  setDepartmentName(dept.name);
  setDepartmentDescription(dept.description);
  setShowUpdateDepartmentModal(true);
};

const handleUpdateDepartment = (e) => {
  e.preventDefault();
  const departmentId = selectedDepartmentId;
  const departmentData = {
    name: departmentName,
    description: departmentDescription,
  };

  axiosInstance.patch(`/department/${departmentId}/`, departmentData)
    .then(response => {
      console.log(response.data);
      setDepartment(department.map(dept => dept.id === departmentId ? response.data : dept));
      setShowUpdateDepartmentModal(false);
    })
    .catch(error => {
      console.error(error);
    });
};

const handleBranchSubmit = (branch) => {
  const selectedBranch = branch;
  const selectedDepartment = selectedBranch.department_name;

  setSelectedBranch(selectedBranch);
  setSelectedDepartmentName(selectedDepartment);

  // NEW: Save probation months
  const probationMonths = selectedBranch.probation_period_months;

  // LocalStorage Save
  localStorage.setItem('selectedBranch', selectedBranch.name);
  localStorage.setItem('selectedBranchId', selectedBranch.id);
  localStorage.setItem('selectedDepartment', selectedDepartment);

  // NEW: Save probation months
  localStorage.setItem('probationMonths', probationMonths);

  window.location.href = '/documents';
};


const handleBranchSelect = (branchName) => {
  const selectedBranch = branch.find((branch) => branch.name === branchName);
  const selectedDepartment = selectedBranch.department;
  setSelectedBranch(selectedBranch);
  localStorage.setItem('selectedBranch', branchName);
  localStorage.setItem('selectedDepartment', selectedDepartment);
};

  const handleSubmit = () => {
    localStorage.setItem('selectedDocumentTypes', selectedDocumentTypes);
    localStorage.setItem('selectedDepartment', selectedDepartmentName);
    localStorage.setItem('selectedBranch', selectedBranch.name);
    window.location.href = '/documents';
  };

  const handleDocumentTypeSelect = (documentType) => {
    const existingTypes = selectedDocumentTypes.includes(documentType);
    if (existingTypes) {
      setSelectedDocumentTypes(selectedDocumentTypes.filter((type) => type !== documentType));
    } else {
      setSelectedDocumentTypes([...selectedDocumentTypes, documentType]);
    }
  };

  const handleDirectGoToDocuments = () => {
    localStorage.setItem('selectedDepartment', selectedDepartmentName);
    localStorage.setItem('selectedBranch', null);
    localStorage.setItem('selectedDocumentTypes', []);
    window.location.href = '/documents';
  };

  const handleCreateDepartment = () => {
    const departmentData = {
      name: departmentName,
      description: departmentDescription,
      branch: {
        name: branchName,
        description: branchDescription,
      },
    };

    axiosInstance.post('/department/', departmentData)
      .then(response => {
        console.log(response.data);
        setDepartment([...department, response.data]);
      })
      .catch(error => {
        console.error(error);
      });
  };

  const handleCreateBranch = (e) => {
    e.preventDefault();
  
    const branchData = {
      department: departmentId,
      name: branchName,
      description: branchDescription,
      probation_period_months: probationPeriodMonths,
    };
  
    axiosInstance.post('/branch/', branchData)
      .then(response => {
        console.log(response.data);
        setBranch([...branch, response.data]);
        setShowBranchModal(false);
      })
      .catch(error => {
        console.error(error);
      });
  };
  
  const handleAssignBranch = async (e) => {
    e.preventDefault();
    if (!selectedBranch || selectedDepartments.length === 0) {
      toast.error("Please select a branch and at least one department");
      return;
    }
  
    try {
      await axiosInstance.post('/assign-branch-departments/', {
        branch: selectedBranch,
        departments: selectedDepartments,
      });
  
      setShowAssignModal(false);
      setSelectedBranch('');
      setSelectedDepartments([]);
      toast.success("Branch assigned successfully!");
    } catch (error) {
      console.error(error);
      toast.error("Error assigning branch");
    }
  };
  
  

  const handleCreateDocumentType = () => {
    if (!selectedDepartmentId) {
      console.error('No department selected!');
      return;
    }
  
    const documentTypeData = {
      name: documentTypeName,
      category: category,
      department: selectedDepartmentId,
    };
  
    axiosInstance.post('/create-document-types/', documentTypeData)
      .then(response => {
        console.log(response.data);
        setDocumentTypes([...documentTypes, response.data]);
        setShowDocumentTypeModal(false);
      })
      .catch(error => {
        console.error(error);
      });
  };

  const handleDelete = (departmentId) => {
    if (window.confirm("Are you sure you want to delete this department?")) {
      axiosInstance.delete(`/department/${departmentId}/`)
        .then(response => {
          setMessage('Department deleted successfully!');
          setDepartment(department.filter(department => department.id !== departmentId));
        })
        .catch(error => {
          if (error.response.data) {
            const errorMessages = Object.keys(error.response.data).map(key => {
              const value = error.response.data[key];
              return Array.isArray(value) ? value.join(', ') : value.toString();
            }).join(', ');
            setMessage(errorMessages);
          } else {
            setMessage('An error occurred. Please try again.');
          }
        });
    }
  };
  
  const handleDeleteBranch = (branchId) => {
    if (window.confirm("Are you sure you want to delete this branch?")) {
      axiosInstance.delete(`/branch/${branchId}/`)
        .then(response => {
          setMessage('Branch deleted successfully!');
          setBranch(branch.filter(branch => branch.id !== branchId));
        })
        .catch(error => {
          if (error.response.data) {
            const errorMessages = Object.keys(error.response.data).map(key => {
              const value = error.response.data[key];
              return Array.isArray(value) ? value.join(', ') : value.toString();
            }).join(', ');
            setMessage(errorMessages);
          } else {
            setMessage('An error occurred. Please try again.');
          }
        });
    }
  };

  const handleDeleteDocumentType = (index) => {
    if (window.confirm("Are you sure you want to delete this document type?")) {
      axiosInstance.delete(`/delete-document-types/${documentTypes[index].id}/`)
        .then(response => {
          if (response.status === 204) {
            const updatedDocumentTypes = [...documentTypes];
            updatedDocumentTypes.splice(index, 1);
            setDocumentTypes(updatedDocumentTypes);
          }
        })
        .catch(error => {
          console.error(error);
        });
    }
  };

  const handleCustomerSubmit = (customer) => {
    const selectedCustomer = customer;
  
    localStorage.setItem('selectedCustomerId', customer.id);
    localStorage.setItem('selectedCustomer', selectedCustomer.name);
  
    window.location.href = '/policies';
  };
  

const handleCreateCustomer = (e) => {
  e.preventDefault();
  const customerData = {
    name: customerName,
    email: customerEmail,
    contact_number: customerContactNumber,
  };

  axiosInstance.post('/customers/', customerData)
    .then(response => {
      console.log("Customer created:", response.data);
      setCustomer([...customer, response.data]);
      setCreatedCustomerId(response.data.id);
      setShowCustomerDocumentModal(true);

      setCustomerName('');
      setCustomerEmail('');
      setCustomerContactNumber('');
    })
    .catch(error => {
      console.error("Create failed:", error);
    });
};


const handleFileChange = (event) => {
  const { name, files } = event.target;
  if (files.length === 0) return;
  console.log(`Setting file for ${name}`, files[0]);
  setDocuments(prev => ({ ...prev, [name]: files[0] }));
}; 

const handleSubmitDocuments = (e) => {
  e.preventDefault();
  const formData = new FormData();

  formData.append('customer', createdCustomerId);

  for (const key in documents) {
    if (documents[key]) {
      formData.append(key, documents[key]);
    }
  }

  axiosInstance.post('/customer-documents/', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })
    .then(res => {
      console.log("Documents uploaded:", res.data);
      setShowCustomerDocumentModal(false);

      setDocuments({
        pan: null, aadhaar: null, gst: null, other1: null, other2: null,
      });
    })
    .catch(err => {
      console.error("Document upload failed:", err);
    });
};

  

const handleUpdateCustomerClick = async (e, customerId) => {
  localStorage.setItem("selectedCustomerId", customerId);
  setSelectedCustomerId(customerId);

  let customerToEdit = customer.find(c => c.id === customerId);

  if (!customerToEdit) {
    try {
      const res = await axiosInstance.get(`/customers/${customerId}/`);
      customerToEdit = res.data;
    } catch (error) {
      console.error("Failed to fetch customer:", error);
      return;
    }
  }

  if (customerToEdit) {
    setCustomerName(customerToEdit.name || '');
    setCustomerEmail(customerToEdit.email || '');
    setCustomerContactNumber(customerToEdit.contact_number || '');
    setShowUpdateCustomerModal(true);
  }
};

  
  const handleUpdateCustomer = (e) => {
    e.preventDefault();
    const customerId = localStorage.getItem("selectedCustomerId");
  
    if (!customerId) {
      console.error("Customer ID is not set");
      return;
    }
  
    const customerData = {};
    if (customerName.trim()) customerData.name = customerName.trim();
    if (customerEmail.trim()) customerData.email = customerEmail.trim();
    if (customerContactNumber.trim()) customerData.contact_number = customerContactNumber.trim();
  
    axiosInstance.put(`/customers/${customerId}/`, customerData)
      .then(response => {
        console.log(response.data);
        setCustomer(prev =>
          prev.map(c => c.id === parseInt(customerId) ? response.data : c)
        );
        setShowUpdateCustomerModal(false);
        localStorage.removeItem("selectedCustomerId");
      })
      .catch(error => {
        console.error("Update failed:", error);
      });
  };
  
  
  
  const handleDeleteCustomer = (customerId) => {
    if (window.confirm("Are you sure you want to delete this customer?")) {
      axiosInstance.delete(`/customers/${customerId}/`)
        .then(response => {
          setMessage('Customer deleted successfully!');
          setCustomer(customer.filter(customer => customer.id !== customerId));
        })
        .catch(error => {
          if (error.response.data) {
            const errorMessages = Object.keys(error.response.data).map(key => {
              const value = error.response.data[key];
              return Array.isArray(value) ? value.join(', ') : value.toString();
            }).join(', ');
            setMessage(errorMessages);
          } else {
            setMessage('An error occurred. Please try again.');
          }
        });
    }
  };
  
  const handleViewCustomerDetails = (customerId) => {
    axiosInstance.get(`/customers/${customerId}/`)
      .then(response => {
        setSelectedCustomer(response.data);
      })
      .catch(error => {
        console.error("Failed to fetch customer details:", error);
      });
  };

  const openCustomerDetailsModal = (customer) => {
    console.log("Opening details modal for customer:", customer);
    setSelectedCustomer(customer);
    setShowCustomerDetailsModal(true);
  
    axiosInstance.get(`/customer-image/${customer.id}/`)
      .then(response => {
        setCustomerDocumentImages(response.data);
      })
      .catch(error => {
        console.error("Error fetching document images:", error);
      });
  };

  const handleCustomerImageUpdate = (event) => {
    event.preventDefault();
  
    const formData = new FormData();
    let added = 0;
  
    document.querySelectorAll('input[type="file"]').forEach((input) => {
      if (input.files.length > 0) {
        formData.append(input.name, input.files[0]);
        added++;
      }
    });
  
    if (added === 0) {
      setMessage('Please select at least one file to update.');
      return;
    }
  
    const customerId = localStorage.getItem('currentCustomerId');
  
    if (!customerId) {
      setMessage('No customer selected for update.');
      return;
    }
  
    axiosInstance.patch(`/customers/${customerId}/documents/`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    .then((response) => {
      setMessage('Documents updated successfully!');
      setShowUpdateCustomerImgModal(false);
      localStorage.removeItem('currentCustomerId');
      // Avoid full reload (backend refetch storm)
      axiosInstance.get('/get-customers/')
        .then(r => {
          setUserCustomers(r.data.customers || []);
        })
        .catch(console.error);
    })
    .catch((error) => {
      console.error(error);
      setMessage('Error updating documents.');
    });
  };
  



  const handleDownloadSingleImage = async (docType) => {
    try {
      const customerId = localStorage.getItem('currentCustomerId');
      if (!customerId) {
        alert('Customer ID not found.');
        return;
      }
  
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_API_BASE_URL}/customers/${customerId}/documents/download/${docType}/`,
        {
          responseType: 'blob',
        }
      );
  
      const disposition = response.headers['content-disposition'];
      let filename = `${docType}_document`;
      if (disposition && disposition.indexOf('filename=') !== -1) {
        const matches = disposition.match(/filename="?([^"]+)"?/);
        if (matches != null && matches[1]) filename = matches[1];
      }
  
      const blob = new Blob([response.data], { type: response.data.type || 'application/octet-stream' });
  
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download error:", error);
      alert("Failed to download document.");
    }
  };
  

const customerDocumentTypes = ['pan', 'aadhaar', 'gst', 'other1', 'other2'];

const handleDownloadImages = async () => {
  const customerId = localStorage.getItem('currentCustomerId');
  if (!customerId) {
    alert('Customer ID not found in localStorage.');
    return;
  }

  try {
    const response = await axiosInstance.get(
      `customers/${customerId}/documents/download-all/`,
      {
        responseType: 'blob',
      }
    );

    const disposition = response.headers['content-disposition'];
    let filename = `customer_${customerId}_documents.zip`;
    if (disposition && disposition.indexOf('filename=') !== -1) {
      const matches = disposition.match(/filename="?([^"]+)"?/);
      if (matches != null && matches[1]) filename = matches[1];
    }

    const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/zip' }));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Error downloading zip:', error);
    alert('Failed to download documents zip.');
  }
};


const handleFileClick = (file, label) => {
  let fileURL;

  if (file instanceof File || file instanceof Blob) {
    fileURL = URL.createObjectURL(file);
  } else if (typeof file === 'string') {
    const secureFile = file.replace(/^http:\/\//i, 'https://');
    fileURL = secureFile.startsWith('http') ? secureFile : `${process.env.REACT_APP_API_BASE_URL}${secureFile}`;
  } else {
    console.error('Unsupported file type');
    return;
  }

  if (/\.pdf(\?.*)?$/i.test(fileURL)) {
    window.open(fileURL, '_blank');
  } else if (/\.(doc|docx)$/i.test(fileURL)) {
    setPreviewFile(fileURL);
    setPreviewLabel(label);
  } else {
    setPreviewFile(fileURL);
    setPreviewLabel(label);
  }
};

  const renderFilePreview = (fileUrl, label, imageId, imageType) => {
    const secureFileUrl = fileUrl?.startsWith('http://')
      ? fileUrl.replace(/^http:\/\//i, 'https://')
      : `${process.env.REACT_APP_API_BASE_URL}${fileUrl}`;
  
    const isImage = /\.(jpg|jpeg|png|webp|gif)$/i.test(secureFileUrl);
    const isPDF = /\.pdf(\?.*)?$/i.test(secureFileUrl); 
    const isDoc = /\.(doc|docx)$/i.test(secureFileUrl);
  
    return (
      <div key={label + imageId} style={{ textAlign: 'center', margin: '5px' }}>
        {isImage ? (
          <img
            src={secureFileUrl}
            alt={label}
            style={{ width: '60px', height: '60px', cursor: 'pointer' }}
            onClick={() => handleImageClick({ id: imageId, url: secureFileUrl, imageType })}
          />
        ) : isPDF ? (
          <div
            style={{
              fontSize: '40px',
              color: 'red',
              cursor: 'pointer',
              fontWeight: 'bold'
            }}
            onClick={() => handleImageClick({ id: imageId, url: secureFileUrl, imageType })}
          >
            <i className="fas fa-file-pdf"></i>
          </div>
        ) : isDoc ? (
          <div
            style={{
              fontSize: '40px',
              color: 'blue',
              cursor: 'pointer',
              fontWeight: 'bold'
            }}
            onClick={() => handleImageClick({ id: imageId, url: secureFileUrl, imageType })}
          >
            <i className="fas fa-file-word"></i>
          </div>
        ) : (
          <div
            style={{
              fontSize: '16px',
              color: 'gray',
              cursor: 'pointer',
              fontWeight: 'bold'
            }}
            onClick={() => handleImageClick({ id: imageId, url: secureFileUrl, imageType })}
          >
            <i className="fas fa-file-alt"></i>
            <div style={{ fontSize: '12px', color: '#666' }}>Unknown File</div>
          </div>
        )}
      </div>
    );
  };
  

  useEffect(() => {
    const loadDocx = async () => {
      if (previewFile && /\.(docx?)$/i.test(previewFile) && docxContainerRef.current) {
        try {
          let secureUrl = previewFile;
          if (secureUrl.startsWith('http://')) {
            secureUrl = secureUrl.replace('http://', 'https://');
          }
  
          const response = await fetch(secureUrl);
          const blob = await response.blob();
          docxContainerRef.current.innerHTML = ""; 
          await renderAsync(blob, docxContainerRef.current);
        } catch (error) {
          console.error("Error rendering DOCX:", error);
        }
      }
    };
  
    loadDocx();
  }, [previewFile]);

  const getFullUrl = (url) => {
    if (!url || typeof url !== 'string') return null;
    if (url.startsWith("http://") || url.startsWith("https://")) return url;
    return backendBaseURL + url;
  };
  
  const filteredBranches = branch.filter((b) => {
    // ✅ department match (array-safe)
    const departmentMatch =
      !selectedDepartmentName ||
      (Array.isArray(b.department_name)
        ? b.department_name.includes(selectedDepartmentName)
        : b.department_name === selectedDepartmentName);
  
    // ✅ branch name filter
    const branchMatch = b.name
      .toLowerCase()
      .includes(branchNameFilter.toLowerCase());
  
    // ✅ role / permission filter
    const permissionMatch =
      ['admin', 'subadmin'].includes(userDepartmentBranch.user_role) ||
      userDepartmentBranch.branches?.some(
        (userBranch) => userBranch.id === b.id
      );
  
    return departmentMatch && branchMatch && permissionMatch;
  });
  

  const filteredDocumentTypes = Object.keys(documentTypes).filter((key) =>
    documentTypes[key].name.toLowerCase().includes(documentTypeFilter.toLowerCase()) ||
    documentTypes[key].category.toLowerCase().includes(documentTypeFilter.toLowerCase())
  );

const indexOfLastBranch = currentPage * rowsPerPage;
const indexOfFirstBranch = indexOfLastBranch - rowsPerPage;
const currentBranches = filteredBranches.slice(indexOfFirstBranch, indexOfLastBranch);

const indexOfLastDocumentType = currentPage * rowsPerPage;
const indexOfFirstDocumentType = indexOfLastDocumentType - rowsPerPage;
const currentDocumentTypes = filteredDocumentTypes.slice(indexOfFirstDocumentType, indexOfLastDocumentType);

const handlePageChange = (pageNumber) => {
  setCurrentPage(pageNumber);
};

const totalPages = Math.ceil(filteredBranches.length / rowsPerPage);
const totalPage = Math.ceil(filteredDocumentTypes.length / rowsPerPage);

const filteredCustomers = userCustomers.customers?.filter(c =>
  c.name.toLowerCase().includes(customerFilter.toLowerCase())
) || [];  

const indexOfLastCustomer = currentPage * rowsPerPage;
const indexOfFirstCustomer = indexOfLastCustomer - rowsPerPage;
const currentCustomers = filteredCustomers.slice(indexOfFirstCustomer, indexOfLastCustomer);

const totalCustomerPages = Math.ceil(filteredCustomers.length / rowsPerPage);
const allowedExtensions = ['pdf', 'doc', 'docx', 'png', 'jpeg', 'jpg', 'svg', 'webp'];

  return (
     <div className="dashboard-wrapper">
          {/* Left Sidebar */}
          <div className="dashboard-sidebar">
  <div className="sidebar-header">
    <img src="/logo.png" alt="Logo" className="sidebar-logo" />
  </div>

  <nav className="sidebar-nav">
    <Link
      to="/admin-dashboard"
      className={`sidebar-link ${activePath === '/admin-dashboard' ? 'active' : ''}`}
    >
      <i className="fas fa-home"></i> Dashboard
    </Link>

    {currentUser?.role_name === 'admin' && (
      <Link
        to="/users"
        className={`sidebar-link ${activePath === '/users' ? 'active' : ''}`}
      >
        <i className="fas fa-users"></i> Users
      </Link>
    )}

    {/* Simplified Departments Link */}
    <Link
      to="/departments"
      className={`sidebar-link ${activePath === '/departments' ? 'active' : ''}`}
    >
      <i className="fas fa-file-alt"></i> Departments
    </Link>
  </nav>
</div>

          <div
        className="dashboard-main"
        style={{
          display: 'flex',
          gap: '20px',
          flexWrap: 'nowrap',
          alignItems: 'flex-start',
          padding: '20px',
        }}
      >
         <div className="dashboard-content" style={{ flex: 3 }}>
        
        <h2>Departments</h2>
        <div
                    className="dashboard-cards"
                    style={{ display: 'flex', flexDirection: 'column', gap: '30px' }}
                  >
                     <motion.div className="dashboard-card">
                                  <div className="card-header">
                                  {currentUser &&
  (['admin', 'subadmin'].includes(currentUser.role_name) || hasPermission('Department Create')) && (
    <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '10px', cursor: 'pointer' }}>
    <button
  className="view-all-btn"
  title="Add Department"
  onClick={() => setShowDepartmentModal(true)}
>
  <span>+ Add Department</span>
</button>

    </div>
)}
                                  </div>
                                </motion.div>
        <Modal
  isOpen={showDepartmentModal}
  onClose={() => setShowDepartmentModal(false)}
  title="Create Department"
  style={{ width: 900 }}
>
<motion.div
          initial={{ y: -100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.5 }}
          className="department-header"
        >
          <div className='doc'>
            <h1>Add Department</h1>
          </div>
        </motion.div>
  <form onSubmit={handleCreateDepartment}>
    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
      
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <label>Department Name:</label>
        <input
          type="text"
          value={departmentName}
          onChange={(e) => setDepartmentName(e.target.value)}
          style={{ width: '300px' }}
        />
      </div>

      <div style={{ alignSelf: 'flex-end' }}>
        <button className='submit-all-btn' type="submit" style={{ height: '36px'  }}>Create Department</button>
      </div>

    </div>
  </form>
</Modal>

<Modal
  isOpen={showAssignModal}
  onClose={() => setShowAssignModal(false)}
  title="Assign Branch to Departments"
  style={{ width: 600 }}
  className="branch-modal"
>
  <motion.div
    initial={{ y: -100, opacity: 0 }}
    animate={{ y: 0, opacity: 1 }}
    transition={{ duration: 0.5 }}
    className="department-header"
  >
    <h1>Assign Branch</h1>
  </motion.div>

  <form onSubmit={handleAssignBranch}>
    <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>

      <div style={{ display: "flex", flexDirection: "column" }}>
        <label>Branch:</label>
        <select
          value={selectedBranch}
          onChange={(e) => setSelectedBranch(e.target.value)}
          style={{ width: "250px" }}
        >
          <option value="">Select a branch</option>
          {branches.map((branch) => (
            <option key={branch.id} value={branch.id}>
              {branch.name}
            </option>
          ))}
        </select>
      </div>

      <div style={{ display: "flex", flexDirection: "column" }}>
        <label>Departments:</label>
        <select
          multiple
          value={selectedDepartments}
          onChange={(e) => {
            const options = e.target.options;
            const values = [];
            for (let i = 0; i < options.length; i++) {
              if (options[i].selected) values.push(parseInt(options[i].value));
            }
            setSelectedDepartments(values);
          }}
          style={{ width: "250px", height: "120px" }}
        >
          {department.map((dept) => (
            <option key={dept.id} value={dept.id}>
              {dept.name}
            </option>
          ))}
        </select>
      </div>

      <div>
        <button type="submit" className="submit-all-btn" style={{ height: "36px" }}>
          Assign
        </button>
      </div>
    </div>
  </form>
</Modal>


<Modal
  isOpen={showBranchModal}
  onClose={() => setShowBranchModal(false)}
  title="Create Branch"
  style={{ width: 1000 }}
  className="branch-modal"
>
  <motion.div
    initial={{ y: -100, opacity: 0 }}
    animate={{ y: 0, opacity: 1 }}
    transition={{ duration: 0.5 }}
    className="department-header"
  >
    <div className="doc">
      <h1>Add Branch</h1>
    </div>
  </motion.div>

  <form onSubmit={handleCreateBranch}>
    <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>

      {/* First Row */}
      <div style={{ display: "flex", alignItems: "flex-end", gap: "15px" }}>
        
        <div style={{ display: "flex", flexDirection: "column" }}>
          <label>Department:</label>
          <select
            value={departmentId}
            onChange={(e) => setDepartmentId(e.target.value)}
            style={{ width: "200px" }}
            className="styled-select"
          >
            <option value="">Select a department</option>
            {department.map((dept) => (
              <option key={dept.id} value={dept.id}>
                {dept.name}
              </option>
            ))}
          </select>
        </div>

        <div style={{ display: "flex", flexDirection: "column" }}>
          <label>Branch Name:</label>
          <input
            type="text"
            value={branchName}
            onChange={(e) => setBranchName(e.target.value)}
            style={{ width: "200px" }}
          />
        </div>

        <div style={{ display: "flex", flexDirection: "column" }}>
          <label>Category:</label>
          <input
            value={branchDescription}
            onChange={(e) => setBranchDescription(e.target.value)}
            style={{ width: "250px" }}
          />
        </div>
      </div>

      {/* Second Row (New Fields) */}
      <div style={{ display: "flex", alignItems: "flex-end", gap: "15px" }}>

        <div style={{ display: "flex", flexDirection: "column" }}>
          <label>Probation Period (Months):</label>
          <input
            type="number"
            value={probationPeriodMonths}
            onChange={(e) => setProbationPeriodMonths(e.target.value)}
            style={{ width: "200px" }}
          />
        </div>

      </div>

      <div>
        <button className="submit-all-btn" type="submit" style={{ height: "36px" }}>
          Create Branch
        </button>
      </div>
    </div>
  </form>
</Modal>


<Modal
  isOpen={showCustomerModal}
  onClose={() => setShowCustomerModal(false)}
  title="Create Customer"
  style={{ width: 1000 }}
  className="customer-modal"
>
<motion.div
          initial={{ y: -100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.5 }}
          className="department-header"
        >
          <div className='doc'>
            <h1>Add Customer</h1>
          </div>
        </motion.div>
  <form onSubmit={handleCreateCustomer}>
    <div style={{ display: 'flex', alignItems: 'flex-end', gap: '15px' }}>
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <label>Name:</label>
        <input
          type="text"
          value={customerName}
          onChange={(e) => setCustomerName(e.target.value)}
          style={{ width: '200px', marginBottom: '0px' }} required
        />
      </div>
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <label>Email:</label>
        <input
          value={customerEmail}
          onChange={(e) => setCustomerEmail(e.target.value)}
          style={{ width: '250px', resize: 'none' }} required
        />
      </div>
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <label>Contact Number:</label>
        <input
          type="tel"
          value={customerContactNumber}
          onChange={(e) => {
            const value = e.target.value;
            if (/^\d{0,10}$/.test(value)) {
              setCustomerContactNumber(value);
            }
          }}
          style={{ width: '250px', }}
          placeholder="Enter 10-digit number"
          maxLength={10}
          required
        />
      </div>
      <div>
        <button className='submit-all-btn' type="submit" style={{ height: '36px' }}>Create Customer</button>
      </div>

    </div>
  </form>
</Modal>

{showCustomerDocumentModal && (
        <div className="modal-overlay">
          <div className="modal-box" style={{ width: 500, background: '#fff', padding: 20 }}>
            <h3>Upload Documents for Customer</h3>
            <form onSubmit={handleSubmitDocuments}>
              <label>PAN:</label>
              <input type="file" name="pan" onChange={handleFileChange} /><br />
              <label>Aadhaar:</label>
              <input type="file" name="aadhaar" onChange={handleFileChange} /><br />
              <label>GST:</label>
              <input type="file" name="gst" onChange={handleFileChange} /><br />
              <label>Other 1:</label>
              <input type="file" name="other1" onChange={handleFileChange} /><br />
              <label>Other 2:</label>
              <input type="file" name="other2" onChange={handleFileChange} /><br />

              <button type="submit">Upload Documents</button>
              <button type="button" onClick={() => setShowCustomerDocumentModal(false)} style={{ marginLeft: 10 }}>
                Cancel
              </button>
            </form>
          </div>
        </div>
      )}

<Modal
  isOpen={showCustomerDetailsModal}
  onClose={() => {
    setShowCustomerDetailsModal(false);
    window.location.reload();
  }}
>
  {selectedCustomer && (
    <div>
      <div className='doc'>
        <h1>Customer Details
          <span>Details related to specific Customers.</span>
        </h1>
      </div>
      <hr />

      <div className="document-info-grid">
        <div className="grid-doc">
          <p><strong>Contact No.:</strong> {selectedCustomer.contact_number}</p>
        </div>
        <div className="grid-doc">
          <p><strong>Email ID:</strong> {selectedCustomer.email}</p>
        </div>
        <div className="grid-doc">
          <p><strong>Name of Customer:</strong> {selectedCustomer.name}</p>
        </div>
      </div>
      <hr />

      {Object.entries(customerDocumentImages).length > 0 ? (
  <div className="form-row-inline">
    {Object.entries(customerDocumentImages).map(([docType, docUrl]) => {
      if (docType === 'id' || docType === 'customer') return null;

      const label = docType.toUpperCase();

      if (!docUrl || typeof docUrl !== 'string') {
        return (
          <div key={label} className="form-inline-item">
            <label style={{ fontSize: '12px', marginLeft: '0px' }}>{label}:</label>
            <p style={{ fontSize: '12px', color: 'gray' }}>Not uploaded</p>
          </div>
        );
      }

      const fullUrl = docUrl;
      const ext = docUrl.split('.').pop().toLowerCase();

      if (!allowedExtensions.includes(ext)) return null;

      let preview;
      if (ext === 'pdf') {
        preview = (
          <div
            className="doc-icon"
            style={{ fontSize: '30px' }}
            onClick={() => window.open(fullUrl, '_blank')}
            title="Click to open PDF"
          >
            <i className="fas fa-file-pdf file-icon" style={{ color: 'red' }}></i>
          </div>
        );
      } else if (ext === 'doc' || ext === 'docx') {
        preview = (
          <div
            className="doc-icon"
            style={{ fontSize: '30px' }}
            onClick={() => window.open(fullUrl, '_blank')}
            title="Click to open DOC"
          >
            <i className="fas fa-file-word file-icon" style={{ color: '#2A5699' }}></i>
          </div>
        );
      } else {
        preview = (
          <img
            src={fullUrl}
            alt={`${label} document`}
            className="doc-image"
            style={{ cursor: 'pointer', maxWidth: '100px' }}
            onClick={() => {
              handleFileClick(fullUrl, label);
              setPreviewImage({ file: fullUrl, label });
            }}
          />
        );
      }

      return (
        <div key={label} className="form-inline-item">
          <label style={{ fontSize: '12px', marginLeft: '0px' }}>{label}:</label>
          <div
            className="doc-preview"
            style={{ cursor: 'pointer' }}
            onClick={() => {
              handleFileClick(fullUrl, label);
              setPreviewImage({ file: fullUrl, label });
            }}
          >
            {renderFilePreview(fullUrl, label)}
          </div>
        </div>
      );      
    })}
  </div>
) : (
  <p>No images found for this document.</p>
)}




<button
  type="button" 
  title="Download Images Zip"
  onClick={handleDownloadImages}
  style={{
    cursor: 'pointer',
    fontSize: '15px',
    color: '#fff',
    backgroundColor: '#000',
    border: '1px solid #ccc',
    borderRadius: '6px',
    padding: '5px 10px',
    fontWeight: 'bold',
    transition: 'background-color 0.3s ease',
  }}
  onMouseEnter={e => (e.currentTarget.style.backgroundColor = '#fff')}
  onMouseLeave={e => (e.currentTarget.style.backgroundColor = '#000')}
>
  Download All
</button>

    </div>
  )}
</Modal>

<Modal isOpen={showUpdateImgModal} onClose={() => setShowUpdateCustomerImgModal(false)}>
  <form onSubmit={handleCustomerImageUpdate} encType="multipart/form-data">
    <div className='doc'>
      <h2>
        Update Customer Documents
      </h2>
    </div>
    <hr />

    <div className="form-row1">
      <div className="form-group">
        <label>Pan</label>
        <input type="file" name="pan" onChange={handleFileChange} />
      </div>
      <div className="form-group">
        <label>Aadhaar</label>
        <input type="file" name="aadhaar" onChange={handleFileChange} />
      </div>
      <div className="form-group">
        <label>GST</label>
        <input type="file" name="gst" onChange={handleFileChange} />
      </div>
      <div className="form-group">
        <label>Other 1</label>
        <input type="file" name="other1" onChange={handleFileChange} />
      </div>
      <div className="form-group">
        <label>Other 2</label>
        <input type="file" name="other2" onChange={handleFileChange} />
      </div>
    </div>

    <button className='submit-all-btn' type="submit">Update Documents</button>
  </form>
  {message && <p style={{ color: 'red' }}>{message}</p>}
</Modal>


<div className="image-grid">
  {['admin', 'subadmin'].includes(userDepartmentBranch.user_role) ? (
    department.map((dept, index) => (
      <motion.div
        key={dept.id}
        initial={{ scale: 0.5, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.5, delay: index * 0.2 }}
        className="grid-item"
      >
        <div onClick={() => handleDepartmentClick(dept.name)} className="tab">
          <div className="tab-content">
            <p>{dept.name}</p>
          </div>
        </div>
      </motion.div>
    ))
  ) : (
    department.filter(dept => userDepartmentBranch.departments?.some(userDept => userDept.id === dept.id)).map((dept, index) => (
      <motion.div
        key={dept.id}
        initial={{ scale: 0.5, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.5, delay: index * 0.2 }}
        className="grid-item"
      >
        <div
  onClick={() => handleDepartmentClick(dept.name)}
  className={`tab ${selectedDepartmentName === dept.name ? 'active' : ''}`}
>
  <div className="tab-content">
    <p>{dept.name}</p>
  </div>
</div>

      </motion.div>
    ))
  )}
</div>
        
{selectedDepartment && (
  <div className='department-tables'>
    {selectedDepartmentName === 'Insurance' ? (
      <div style={{ width: '100%' }}>
   {(currentUser && (currentUser.role_name === 'admin' || currentUser.role_name === 'subadmin' || hasPermission('Add Customer'))) && (
  <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '5px', cursor: 'pointer' }}>
   <button
  className="view-all-btn"
  title="Add Customer"
  onClick={() => setShowCustomerModal(true)}
>
  <span>+ Add Customer</span>
</button>

  </div>
)}
        <table className="striped-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Contact Number</th>
              <th>Email</th>
              <th>Actions</th>
              <th>Submit</th>
            </tr>
          </thead>
          <tbody>
            {userCustomers.map((customer, index) => (
              <tr key={index}>
                <td>{customer.name}</td>
                <td>{customer.contact_number}</td>
                <td>{customer.email}</td>
                <td>
  {(hasPermission('View Customer') || (currentUser && (currentUser.role_name === 'admin' || currentUser.role_name === 'subadmin' ))) && (
    <i
      className="fas fa-eye"
      title="View Customer"
      onClick={() => {
        localStorage.setItem('currentCustomerId', customer.id);
        openCustomerDetailsModal(customer);
      }}
      style={{ cursor: 'pointer', marginRight: '10px' }}
    ></i>
  )}

  {(hasPermission('Update Customer Doc') || (currentUser && (currentUser.role_name === 'admin' || currentUser.role_name === 'subadmin' ))) && (
    <i 
      className="fas fa-edit" 
      title="Update Customer" 
      onClick={(e) => handleUpdateCustomerClick(e, customer.id)}
      style={{ cursor: 'pointer', marginRight: '10px' }}
    ></i>
  )}

  {(hasPermission('Delete Customer') || (currentUser && currentUser.role_name === 'admin')) && (
    <i 
      className="fas fa-trash" 
      title="Delete Customer" 
      onClick={() => handleDeleteCustomer(customer.id)} 
      style={{ cursor: 'pointer', marginRight: '10px' }}
    ></i>
  )}

  {(hasPermission('Update Customer Doc') || (currentUser && (currentUser.role_name === 'admin' || currentUser.role_name === 'subadmin' ))) && (
    <i
      className="fas fa-upload"
      title="Upload Documents"
      onClick={() => {
        localStorage.setItem('currentCustomerId', customer.id);
        setShowUpdateCustomerImgModal(true);
      }}
      style={{ cursor: 'pointer', marginRight: '10px' }}
    ></i>
  )}
</td>
                <td>
                    <i
                      className="fa fa-paper-plane"
                      aria-hidden="true"
                      title="Submit All"
                      style={{ fontSize: '20px', cursor: 'pointer', color: 'black' }}
                      onClick={() => handleCustomerSubmit(customer)}
                    />
                </td>
              </tr>
            ))}
          </tbody>

        </table>
      </div>
    ) : (
      <div style={{ display: 'grid', gap: '40px' }}>
        
        <div>
         {currentUser && (currentUser.role_name === 'admin' || currentUser.role_name === 'subadmin' || hasPermission('Create Branch')) && (
  <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginBottom: '-20px' }}>
    <button
      className="view-all-btn"
      title="Add Branch"
      onClick={() => setShowBranchModal(true)}
    >
      <span>+ Add Branch</span>
    </button>

  </div>
)}

         

          <div style={{ marginBottom: '10px', textAlign: 'left' }}>
            <input
              type="text"
              placeholder="Filter by Branch Name"
              value={branchNameFilter}
              onChange={(e) => setBranchNameFilter(e.target.value)}
              style={{
                padding: '3px 10px',
                fontSize: '12px',
                width: '230px',
                borderRadius: '5px',
                border: '1px solid #000',
                marginBottom: '0px',
                display: 'inline-block'
              }}
            />
          </div>

          <table className="striped-table">
            <thead>
              <tr>
                <th className='doc-name'>Branch Name</th>
                <th>Department</th>
               <th>Actions</th>
                <th>Submit</th>
              </tr>
            </thead>
            <tbody>
              {currentBranches.map((branch, index) => (
                <tr key={index}>
                  <td>{branch.name}</td>
                  <td>
                      {Array.isArray(branch.department_name)
                        ? branch.department_name.join(', ')
                        : branch.department_name}
                    </td>
                  <td>
                  {(currentUser && (currentUser.role_name === 'admin' || currentUser.role_name === 'subadmin' || hasPermission('Update Branch'))) && (
                      <i 
                        className="fas fa-edit" 
                        title="Update Branch" 
                        onClick={(e) => handleUpdateBranchClick(e, branch.id)} 
                        style={{ cursor: 'pointer', marginRight: '10px' }}
                      ></i>
                    )}

{(currentUser && (currentUser.role_name === 'admin' || hasPermission('Delete Branch'))) && (
  <i 
    className="fas fa-trash" 
    title="Delete Branch" 
    onClick={() => handleDeleteBranch(branch.id)} 
    style={{ cursor: 'pointer', marginRight: '10px' }}
  ></i>
)}

                  </td>

                  <td>
                      <i
                        className="fa fa-paper-plane"
                        aria-hidden="true"
                        title="Submit Branch"
                        style={{ fontSize: '20px', cursor: 'pointer', color: 'black' }}
                        onClick={() => handleBranchSubmit(branch)}
                      ></i>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {totalPages > 1 && (
            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '15px' }}>
              <button
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
                style={{
                  padding: '0px 10px',
                  margin: '0 5px',
                  cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
                  backgroundColor: '#ddd',
                  border: 'none',
                  borderRadius: '5px',
                  fontSize: '12px'
                }}
              >
                Previous
              </button>
              <span style={{ padding: '3px 12px', fontSize: '12px' }}>
                Page {currentPage} of {totalPages}
              </span>
              <button
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
                style={{
                  padding: '0px 10px',
                  margin: '0 5px',
                  cursor: currentPage === totalPages ? 'not-allowed' : 'pointer',
                  backgroundColor: '#ddd',
                  border: 'none',
                  borderRadius: '5px',
                  fontSize: '12px'
                }}
              >
                Next
              </button>
            </div>
          )}
        </div>
      </div>
    )}
  </div>
)}
</div>
<Modal
  isOpen={showDocumentTypeModal}
  onClose={() => setShowDocumentTypeModal(false)}
  title="Create Document Type"
  style={{ width: 900 }}
>
  <form onSubmit={handleCreateDocumentType}>
    <div style={{ display: 'flex', alignItems: 'flex-end', gap: '15px' }}>
      
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <label>Document Type Name:</label>
        <input
          type="text"
          value={documentTypeName}
          onChange={(e) => setDocumentTypeName(e.target.value)}
          style={{ width: '300px', marginBottom: '0px' }}
        />
      </div>

      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <label>Category:</label>
        <input
          value={category}
          onChange={(e) => setCategory(e.target.value)}
          style={{ width: '380px', resize: 'none' }}
        />
      </div>

      <div>
        <button className='submit-all-btn' type="submit" style={{ height: '36px' }}>
          Create Document Type
        </button>
      </div>

    </div>
  </form>
</Modal>

<Modal
  isOpen={showUpdateDepartmentModal}
  onClose={() => setShowUpdateDepartmentModal(false)}
  title="Update Branch"
  style={{ width: 600 }}
>
  <form onSubmit={handleUpdateBranch}>

    <div
      style={{
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        gap: "20px",
        marginTop: "15px",
      }}
    >
      {/* Branch Name */}
      <div style={{ display: "flex", flexDirection: "column" }}>
        <label>Branch Name:</label>
        <input
          type="text"
          value={branchName}
          onChange={(e) => setBranchName(e.target.value)}
        />
      </div>

      {/* Probation Months */}
      <div style={{ display: "flex", flexDirection: "column" }}>
        <label>Probation Period (Months):</label>
        <input
          type="number"
          value={probationPeriodMonths}
          onChange={(e) => setProbationPeriodMonths(e.target.value)}
        />
      </div>
    </div>

    <button
      type="submit"
      className="submit-all-btn"
      style={{ marginTop: "20px"}}
    >
      Update Branch
    </button>
  </form>
</Modal>



<Modal
  isOpen={showUpdateCustomerModal}
  onClose={() => setShowUpdateCustomerModal(false)}
  title="Update Customer"
  style={{ width: 500 }}
>
  <form onSubmit={handleUpdateCustomer}>
    <label>Name:</label>
    <input
  type="text"
  value={customerName}
  onChange={(e) => setCustomerName(e.target.value)}
/>

    <label>Email:</label>
    <input
  type="email"
  value={customerEmail}
  onChange={(e) => setCustomerEmail(e.target.value)}
/>

    <label>Contact Number:</label>
    <input
  type="text"
  value={customerContactNumber}
  onChange={(e) => {
    const value = e.target.value;
    if (/^\d{0,10}$/.test(value)) {
      setCustomerContactNumber(value);
    }
  }}
  maxLength={10}
  placeholder="Enter 10-digit number"
/>


    <button className='submit-all-btn' type="submit">Update Customer</button>
  </form>
</Modal>

{previewFile && (
  <div className="modal-overlay" onClick={() => setPreviewFile(null)}>
    <div className="preview-modal-content" onClick={(e) => e.stopPropagation()}>
      <div className="popup-header">
        <span className="close-icon" onClick={() => setPreviewFile(null)}>×</span>
      </div>
      
      <h4>{previewLabel}</h4>

      {/\.(pdf)$/i.test(previewFile) ? (
        <iframe
          src={previewFile}
          width="100%"
          height="500px"
          title="PDF Viewer"
          frameBorder="0"
        />
      ) : /\.(docx?)$/i.test(previewFile) ? (
        <div
          ref={docxContainerRef}
          style={{
            maxHeight: '500px',
            overflow: 'auto',
            border: '1px solid #ccc',
            padding: '10px',
          }}
        />
      ) : (
        <img
          src={previewFile}
          alt={previewLabel}
          style={{ maxWidth: '100%', maxHeight: '400px' }}
        />
      )}

      <button
        className="download-button"
        onClick={() => handleDownloadSingleImage(previewLabel.toLowerCase())}
      >
        Download
      </button>
    </div>
  </div>
)}
</div>
</div>
    </div>
  );
}

export default Department;